import BaseAccountController from '../../lib/controllers/BaseAccountController';
import queryParameterParser from '../../lib/helpers/queryStringParser';

declare var LtFramework: lt.Static;

export default class ResetPasswordController extends BaseAccountController {
	public static $inject: string[] = ['$scope', '$window', 'UserPasswordTokenResource'];

	public token: string | null;
	public resetType: string;
	public newPassword: string;
	public newPasswordConfirmation: string;
	public updateFailed: boolean;
	public updateSuccessful: boolean;

	private readonly UserPasswordToken: MyAccountApi.IUserPasswordTokenResource;

	constructor($scope: ng.IScope, $window: ng.IWindowService, UserPasswordToken: MyAccountApi.IUserPasswordTokenResource) {
		super($scope);

		this.UserPasswordToken = UserPasswordToken;

		this.token = queryParameterParser.getParameterByName($window, 'token');
		this.resetType = LtFramework.global.lt.pageProperties.experienceType === 'member' ? 'mylt' : 'lthealth';
	}

	public resetPassword(form: ng.IFormController): void {
		this.updateFailed = false;
		this.updateSuccessful = false;

		if (!form.$invalid) {
			this.UserPasswordToken.save({ token: this.token, newPassword: this.newPassword, resetType: this.resetType }, () => {
				this.updateSuccessful = true;
			}, () => {
				this.updateFailed = true;
			});
		}
	}

	public validateConfirmPassword(ctrl: ng.INgModelController): void {
		ctrl.$setValidity('matchesPassword', this.newPassword === this.newPasswordConfirmation);
	}

	/**
	 * Triggered whenever SSO ID is available/changed
	 */
	protected loadData(): void {
		return;
	}

	/**
	 * Triggered whenever profile data is available/changed
	 */
	protected profileDataLoaded(): void {
		return;
	}
}
